import React from 'react';
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LineSkeleton } from '../../Skeletons/skeletonTemplates';

export default function DescriptionComponent(props) {
    
    function fetchDescriptionHTML() {
        if (props.data && props.data.content)
            return (
                <>
                    <h4 className = "font-weight-bold text-left mt-4">Course Description</h4>
                    <div className = "text-muted text-left urw-din text-lg course-pay-content" dangerouslySetInnerHTML={{ __html: props.data.content }} />
                </>
            );
        return  <></>
    }

    function fetchLearningsSectionHTML() {
        if (props.data && props.data.what_you_will_learn)
            return (
                <div>
                    <h4 className = "font-weight-bold mt-3 text-left">What You Will Learn</h4>
                    <div className = "formatHtml text-muted text-left urw-din text-lg" dangerouslySetInnerHTML={{ __html: props.data.what_you_will_learn }} />
                </div>
            )
    }

    return (
        <section id = "paymentsDescription w-100">
            <div className = "container">
                {props.data 
                    ?
                        <p className = "font-weight-bold text-left courseName sofia-pro">{props.data.course_name}</p>
                    :
                        LineSkeleton(2)
                }
                {props.data ? 
                    (props.data.courseType !== "Live Course" && props.data.instructor_name) ?  
                        (
                            <div className = "row">
                                <img className = "col-md-1 col-xl-1 img-fluid rounded-circle profile-image" src = {props.data.profile_image}></img>
                                <p className = "col-md-9 col-xl-10 text-left text-muted pr-0 pl-0 my-auto"> with {props.data.instructor_name}<span className = "ml-2 mr-2"></span>{props.data.courseType}<span className = "ml-2 mr-2"></span>    <img className = "pl-0 pr-0 star-icon" src = "https://media.geeksforgeeks.org/img-practice/Polygon20-1622098726.png"/>{props.data.courseRating}</p>
                            </div>
                        ) :    
                        (
                            <p className = "text-muted w-100 text-left">{props.data.courseType}
                            {props.data.courseRating ? 
                                <div className = "d-inline">
                                    <span className = "ml-2 mr-0 v1"></span>
                                    <img className = "pl-0 pr-0 star-icon" src = "https://media.geeksforgeeks.org/img-practice/Polygon20-1622098726.png"/>{props.data.courseRating}
                                </div> : <div /> 
                            }
                            </p>
                        )
                : <></>}
                <div>
                    {props.data 
                        ?
                            fetchDescriptionHTML()
                        :
                            <>
                                <h4 className = "font-weight-bold text-left mt-4">Course Description</h4>
                                {LineSkeleton(10)}
                            </>
                    }
                </div>
                {props.data ?
                    fetchLearningsSectionHTML()
                    : 
                    <>
                        <h4 className = "font-weight-bold mt-3 text-left">What You Will Learn</h4>
                        {LineSkeleton(10)}
                    </>
                }
                <h4 className = "font-weight-bold mt-3 text-left">Contact at</h4>
                <p className = "text-muted text-left urw-din">courses@geeksforgeeks.org</p>
            </div>
        </section>
    );
}
